import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface TagProps extends HTMLAttributes<HTMLDivElement> {}

export default function Tag({ children, ...props }: TagProps) {
	return (
		<div
			css={css`
				border-radius: 8px;
				background: var(--bg-on-body-2);
				padding: 4px 8px;
				font-size: 12px;
				color: var(--tint-tertiary);
				display: flex;
				gap: 4px;
				align-items: center;
			`}
			{...props}
		>
			{children}
		</div>
	)
}
